<template>
  <div/>
</template>
<script>
export default {
  name: 'emptyActionParams',
  created() {
    const result = this.$_.cloneDeep(this.value)
    result.parameters = null
    this.$emit('update:value', result)
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
}
</script>
